import gql from 'graphql-tag';

export const RECURRING_ORDER_STATUS_MUTATION = gql`
  mutation EditRecurringOrderStatus($id: Int!, $new_status: String!) {
    editRecurringOrderStatus(input: { recurring_order_id: $id, new_status: $new_status }) {
      updated_recurring_order {
        id
        status
        updated_at
      }
      orders_created {
        id
      }
      plantings_created {
        id
      }
      tasks_created {
        id
      }
      deleted_orders {
        id
      }
      deleted_inputs {
        id
      }
      deleted_plantings {
        id
      }
      deleted_tasks {
        id
      }
    }
  }
`;
